module.exports = __webpack_public_path__ + "img/cat-2.658e9f43.svg";